import { CommunityGroupService } from './community-group.service';

/** One session per component; a failed request keeps its key for an unchanged-payload retry. */
export class CommunityMutationSession {
  private keys = new Map<string, string>();
  constructor(private service: CommunityGroupService) {}
  async run<T = any>(method: string, params: object): Promise<T> {
    const fingerprint = JSON.stringify([method, params]);
    const key = this.keys.get(fingerprint) || this.service.operationKey();
    this.keys.set(fingerprint, key);
    const result = await this.service.mutate<T>(method, params, key);
    this.keys.delete(fingerprint);
    return result;
  }
}
